<template>
  <v-row align="center" justify="center">
    <v-col class="mr-md-n12 hero-cta" cols="12" md="6">
      <p class="hero-text">{{ data.header_cta[0].text }}</p>
      <p class="headline" v-if="data.cta_subtitle.length > 0">{{ data.cta_subtitle[0].text }}</p>
      <v-row>
        <v-col cols="12">
          <v-btn
            depressed
            color="primary"
            md="6"
            min-width="156px"
            class="ma-0"
            @click.stop="registerDialog = !registerDialog"
          >{{ $t('common.sign-up')}}</v-btn>
        </v-col>
      </v-row>
    </v-col>
    <v-col class="ml-md-n12" cols="12" md="6">
      <v-img
        :src="'https://res.cloudinary.com/twodm/image/fetch/' + data.hero_image.url"
        contain
        height="auto"
      ></v-img>
    </v-col>
    <v-dialog v-model="showSubmissionDialog" max-width="600">
      <v-card>
        <v-img
          class="white--text align-start"
          height="100px"
          src="https://cdn.vuetifyjs.com/images/cards/docks.jpg"
        >
          <div class="float-right ma-2">
            <v-icon large right color="white"
            @click="showSubmissionDialog = false">mdi-close</v-icon>
          </div>
        </v-img>
        <v-card-title class="justify-center text-center">
          <h1 class="title">{{ $t('eoiForm.heading') }}</h1>
        </v-card-title>
        <v-card-text class="text--primary" v-if="!submissionSuccess">
          <div class="text-center">{{ $t('eoiForm.subheading') }}</div>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-hover v-slot:default="{ hover }">
                <v-card
                  :elevation="hover ? 12 : 2"
                  outlined
                  class="text-center"
                  @click="selectAccountType('brand')"
                >
                  <v-card-title class="justify-center">
                    <v-icon>mdi-domain</v-icon>
                  </v-card-title>
                  <v-card-text>{{$t('naviForm.im-brand')}}</v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-hover v-slot:default="{ hover }">
                <v-card
                  :elevation="hover ? 12 : 2"
                  outlined
                  class="text-center"
                  @click="selectAccountType('influencer')"
                >
                  <v-card-title class="justify-center">
                    <v-icon>mdi-bullhorn</v-icon>
                  </v-card-title>
                  <v-card-text>{{$t('naviForm.im-influecner')}}</v-card-text>
                </v-card>
              </v-hover>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text v-else>
          <v-card-title class="justify-center">
            <v-icon color="success">mdi-check</v-icon>
            <span class="pl-1">{{ $t('eoiForm.success') }} !</span>
          </v-card-title>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="registerDialog" max-width="1070">
      <v-card class="px-10 pt-10 pb-10">
        <v-row>
          <v-col :md="4" :sm="12" @click="handleOpen('insight')">
            <NaviGuide
              :title="$t('home.social-insights')"
              :desc="$t('home.social-insights-desc')"
              :img="imgInsight" />
          </v-col>
          <v-col :md="4" :sm="12" @click="handleOpen('brand')">
            <NaviGuide
              :title="$t('home.brand')"
              :desc="$t('home.brand-desc')"
              :img="imgBrand" />
          </v-col>
          <v-col :md="4" :sm="12" @click="handleOpen('kol')">
            <NaviGuide
              :title="$t('home.influcer')"
              :desc="$t('home.influcer-desc')"
              :img="imgKol" />
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from 'axios';
import NaviGuide from './NaviGuide';

export default {
  components: {
    NaviGuide,
  },
  name: 'hero',
  props: {
    data: Object,
  },
  data: () => ({
    brandRegister: `${process.env.VUE_APP_NAVIGATE_BRAND}register`,
    kolRegister: `${process.env.VUE_APP_NAVIGATE_KOL}register`,
    insightRegister: `${process.env.VUE_APP_NAVIGATE_INSIGHTS}`,
    // eslint-disable-next-line global-require
    imgInsight: require('../assets/person-insights.svg'),
    // eslint-disable-next-line global-require
    imgBrand: require('../assets/person-brand.svg'),
    // eslint-disable-next-line global-require
    imgKol: require('../assets/person-kol.svg'),
    env: process.env,
    registerDialog: false,
    submissionSuccess: false,
    form: {
      email: '',
      firstname: '',
      type: '',
      company: '',
      hs_language: localStorage.lang,
    },
    emailRules: [
      v => !!v || this.$t('naviForm.emailRequire'),
      v => /.+@.+\..+/.test(v) || this.$t('naviForm.emailValid'),
    ],
    showSubmissionDialog: false,
  }),
  methods: {
    handleOpen(str) {
      // eslint-disable-next-line no-restricted-globals
      if (str === 'kol') location.href = this.kolRegister;
      // eslint-disable-next-line no-restricted-globals
      if (str === 'insight') location.href = this.insightRegister;
      // eslint-disable-next-line no-restricted-globals
      if (str === 'brand') location.href = this.brandRegister;
    },
    selectAccountType(type) {
      this.$store.dispatch('setEmail', {
        email: this.form.email,
        accountType: type,
      });
      this.$router.push('/get-started');
    },
    // eslint-disable-next-line consistent-return
    getCookie(name) {
      const match = document.cookie.match(new RegExp(`${name}=([^;]+)`));
      if (match) return match[1];
    },
    reset() {
      this.$refs.form.reset();
      this.form.company = '';
      this.form.firstname = '';
      this.form.hs_language = '';
    },
    signUp() {
      // if (this.$refs.form.validate()) {
      //   this.showSubmissionDialog = !this.showSubmissionDialog;
      // }
    },
    submitForm() {
      const submitUrl = 'https://api.hsforms.com/submissions/v3/integration/submit/6517596/264eca34-05f6-4fc0-9d38-482204eb5ffc';
      axios
        .post(submitUrl, {
          fields: [
            {
              name: 'email',
              value: this.form.email,
            },
            {
              name: 'company',
              value: this.form.company,
            },
            {
              name: 'type',
              value: this.form.type,
            },
            {
              name: 'firstname',
              value: this.form.firstname,
            },
            {
              name: 'hs_language',
              value: this.form.hs_language,
            },
          ],
          context: {
            hutk: this.getCookie('hubspotutk'),
            pageUri: 'navigate.network',
            pageName: 'Navigate Home',
          },
        })
        .then(() => {
          this.submissionSuccess = true;
          this.reset();
        });
    },
  },
};
</script>

<style scoped>
.hero-cta {
  z-index: 1;
}
.hero-text {
  font-family: Maxwell, Arial, serif;
  font-size: calc(2.4rem + (10 * (100vw - 800px) / 624));
  line-height: 1.0625;
  color: black;
}
</style>
